import React from 'react';
import { Card, CardContent } from './ui/card';
import { Code, Layers, Shield, Zap, GitBranch, FileCode } from 'lucide-react';

const features = [
  {
    icon: Code,
    title: 'Clean Architecture',
    description: 'Generate APIs following Robert C. Martin\'s Clean Architecture principles with proper separation of concerns.'
  },
  {
    icon: Layers,
    title: 'Layered Structure',
    description: 'Automatically creates Domain, Application, Infrastructure, and Presentation layers with proper dependencies.'
  },
  {
    icon: Shield,
    title: 'Enterprise Ready',
    description: 'Production-ready code with error handling, validation, logging, and security best practices built-in.'
  },
  {
    icon: Zap,
    title: 'Lightning Fast',
    description: 'Generate complete API projects in minutes. What would take weeks now takes just 5 minutes.'
  },
  {
    icon: GitBranch,
    title: 'SOLID Principles',
    description: 'Code follows SOLID principles ensuring maintainability, testability, and scalability.'
  },
  {
    icon: FileCode,
    title: 'Complete Documentation',
    description: 'Automatically generates API documentation, code comments, and implementation guides.'
  }
];

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 lg:py-32 bg-muted/30">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Powerful Features for Modern Development
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to build enterprise-grade .NET APIs with Clean Architecture
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card 
                key={index}
                className="group border-2 hover:border-primary/50 transition-all hover:shadow-lg bg-card"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
